import TitleFromTooltip from "./TitleFromTooltip";

export default TitleFromTooltip;
